import { render, staticRenderFns } from "./productView.vue?vue&type=template&id=69e1492e&scoped=true"
import script from "./productView.vue?vue&type=script&lang=js"
export * from "./productView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e1492e",
  null
  
)

export default component.exports